import type { NextArrivalDto } from "../../../types/dtos/api/stop-platform.dto";

/**
 * Stable React key for a stop popup arrival row.
 * Uses trip id and arrival timestamp so a departed vehicle exits without colliding
 * with the next trip on the same line.
 *
 * @param stopId Stop identifier for the open popup.
 * @param arrival Upcoming arrival row from the API.
 * @returns Stable list key for {@link AnimatePresence}.
 */
export const buildStopPopupArrivalRowKey = (
    stopId: string,
    arrival: NextArrivalDto,
): string => {
    const timeKey = arrival.arrival ?? arrival.scheduledArrival ?? "notime";

    return `${ stopId }-${ arrival.tripId }-${ timeKey }`;
};
